import { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { LenisContext } from "@/lib/motion";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const lenisRef = useContext(LenisContext);
  useEffect(() => {
    let cancelled = false;
    const run = (attempt = 0) => {
      if (cancelled) return;
      const lenis = lenisRef && lenisRef.current;
      if (hash) {
        const el = document.querySelector(hash);
        if (!el) return;
        if (lenis) lenis.scrollTo(el, { offset: -80, duration: 1.0 });
        else if (attempt < 12) setTimeout(() => run(attempt + 1), 60);
        else el.scrollIntoView({ behavior: "smooth" });
        return;
      }
      if (lenis) lenis.scrollTo(0, { immediate: true });
      else if (attempt < 12) setTimeout(() => run(attempt + 1), 60);
      else window.scrollTo(0, 0);
    };
    run();
    return () => { cancelled = true; };
  }, [pathname, hash, lenisRef]);
  return null;
}
